import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  Parsed1120Data,
  Parsed1120FieldType,
} from "store/apis/filingDraftReview";

export type ReviewDraftState = {
  reviewData: Parsed1120Data | null;
  deletedFields: string[];
  editedFields: string[];
  errorRemovedFields: string[];
};

const initialState: ReviewDraftState = {
  reviewData: null,
  deletedFields: [],
  editedFields: [],
  errorRemovedFields: [],
};

export const filingDraftReview = createSlice({
  name: "filingDraftReview",
  initialState,
  reducers: {
    setFilingDraftForReview: (
      state,
      action: PayloadAction<Parsed1120Data | null>
    ) => {
      state.reviewData = action.payload;
    },
    setFilingDraftEditedFields: (state, action: PayloadAction<string[]>) => {
      state.editedFields = action.payload;
    },
    setFilingDraftDeletedFields: (state, action: PayloadAction<string[]>) => {
      state.deletedFields = action.payload;
    },
    setFilingDraftErrorRemovedFields: (
      state,
      action: PayloadAction<string[]>
    ) => {
      state.errorRemovedFields = action.payload;
    },
    resetFilingDraftForReview: (state) => {
      state.reviewData = null;
      state.editedFields = [];
      state.deletedFields = [];
      state.errorRemovedFields = [];
    },
  },
});

export const {
  setFilingDraftForReview,
  resetFilingDraftForReview,
  setFilingDraftEditedFields,
  setFilingDraftDeletedFields,
  setFilingDraftErrorRemovedFields,
} = filingDraftReview.actions;

export default filingDraftReview.reducer;
